import React from 'react'
import OutsideClickHandler from 'react-outside-click-handler';
import '../css/index.css'
export const ViewModels = (props) => {
    const style={
        fontSize:'12px',
        textAlign:'left',        
        
    }
    const lableStyle={
        fontSize:'14px',
        fontWeight:'bold'
    }
    return (

        <div className="viewmodale" >
            <OutsideClickHandler
                onOutsideClick={() => {
                    props.setModalStatus2(false)
                }}
            >
                {props.isModalOpen && (
                    <div className="modal fade show " id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog">
                            <div className="modal-content ">
                                <div className="modal-header " >
                                    <h5 className="modal-title m-auto" id="exampleModalLabel">{props.typeOfComplaint}</h5>
                                    {/* <button type="button" className="btn-close m-left" data-bs-dismiss="modal" aria-label="Close" onClick={() => { props.setModalStatus2(false) }} ></button> */}
                                </div>
                                <div className="modal-body viewmodale">
                                    <div className="container">
                                        <div className="row">
                                            <div className="form-group col-md-6  " style={style}>
                                                <label htmlFor="Name"  style={lableStyle}>Name:</label>
                                                <p>{props.name}</p>
                                            </div>
                                            <div className="form-group col-md-6  "style={style}>
                                                <label htmlFor="Phone" style={lableStyle}>Phone Number:</label>
                                            <p>{props.pNumber}</p>
                                            </div>
                                            <div className="form-group col-md-6  " style={style}>
                                                <label htmlFor="Alternative" style={lableStyle}>Alternative Number:</label>
                                                <p>{props.aNumber}</p>
                                            </div>
                                            <div className="form-group col-md-6  " style={style}>
                                                <label htmlFor="Company" style={lableStyle}>Product Company Name:</label>
                                                <p>{props.brandName}</p>
                                            </div>
                                            <div className="form-group col-md-6  " style={style}>
                                                <label htmlFor="Model" style={lableStyle}>Product Name:</label>
                                                <p>{props.modal}</p>
                                            </div>
                                            <div className="form-group col-md-6  " style={style}>
                                                <label htmlFor="Serial" style={lableStyle}>Serial Number:</label>
                                                <p>{props.serialNumber}</p>
                                            </div>
                                            <div className="form-group col-md-6  " style={style}>
                                                <label htmlFor="Date" style={lableStyle}>Date Purchace:</label>
                                                <p>{props.pDate}</p>
                                            </div>
                                            <div className="form-group col-md-6  " style={style}>
                                                <label htmlFor="Address" style={lableStyle}>Full Address:</label>
                                                <p>{props.Address}</p>
                                            </div>
                                            <div className="form-group col-md-6  " style={style}>
                                                <label htmlFor="Pincode" style={lableStyle}>Pincode:</label>
                                                <p>{props.Pincode}</p>
                                            </div>

                                            <div className="form-group col-md-6  " style={style}>
                                                <label htmlFor="Issue" style={lableStyle}>Issue:</label>
                                                <p>{props.Issue}</p>
                                            </div>
                                            <div className="form-group col-md-6  " style={style}>
                                                <label htmlFor="Issue" style={lableStyle}>Type Of Complaint:</label>
                                                <p>{props.typeOfComplaint}</p>
                                            </div>
                                            <div className="form-group col-md-6  " style={style}>
                                                <label htmlFor="Name" style={lableStyle}>ComplaintNumber:</label>
                                                <p>{props.complaintNumber}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" onClick={() => { props.setModalStatus2(false) }} className="btn btn-primary">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </OutsideClickHandler>
        </div>
    )
}
